<template>
  <div id="signUp">
    <div class="container signUp-inner">
      <h2>Get Started</h2>
      <form>
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6 mt-5">
              <input type="text" class="form-control" placeholder="Name">
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 mt-5">
              <input type="email" class="form-control" placeholder="Email">
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 mt-5">
              <input type="text" class="form-control" placeholder="Organization">
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 mt-5">
              <input type="text" class="form-control" placeholder="Telephone Number">
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 mt-5">
              <button class="btn btn-light">Sign Up</button>
            </div> 
          </div>
        </form>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>